import React, { useState, useMemo } from 'react';
import { Dialog, TabsAlignment as ALIGNMENT, TabbedContent } from 'wix-ui-tpa/cssVars';
import { classes, st } from './emotion-list-modal-component.st.css';
import { resolveMainReactionName } from '../../default-reactions';
import { ReactionIcon } from '../../reaction-icon/reaction-icon';
import { getReactionName } from '../../utils/reaction-converters';
import { isDefined } from '../../../ts-utils';
import { keyBy } from 'lodash';
import { TextExtended } from '../../text-extended/text-extended';
import { EMOTION_LIST_MODAL, EMOTION_LIST_MODAL_TABLIST } from '../../data-hooks';
import cssVars from '../../styles/css-vars.scss';
export const EmotionListModalComponent = ({ toggle, totalCount, reactions, config, onTabChange, t, isMobile, isRtl, children: renderChildren, }) => {
    const [activeTabIdx, setActiveTabIdx] = useState(0);
    const mainReactionName = resolveMainReactionName(config.mainEmotion);
    const tabItems = useMemo(() => {
        const items = reactions
            .filter((r) => r.total)
            .map((r) => ({
            id: r.reactionCode,
            title: `${r.total}`,
            prefix: (React.createElement(ReactionIcon, { className: classes.reaction, reactionName: getReactionName(r.reactionCode, mainReactionName) })),
        }));
        return [
            { id: 'all', title: t('reaction-list-modal.all-tab', { count: totalCount }) },
            ...items,
        ];
    }, [reactions, totalCount, mainReactionName, t]);
    const allReactionOwners = useMemo(() => {
        return reactions
            .map((r) => {
            return r.identities.map((i) => ({
                id: i.identityId,
                reactionCode: r.reactionCode,
            }));
        })
            .flat();
    }, [reactions]);
    const ownersByReactionType = useMemo(() => {
        const ownersByReactionType = reactions.map((r) => ({
            reactionCode: r.reactionCode,
            list: r.identities.map((identity) => identity.identityId).filter(isDefined),
        }));
        return keyBy(ownersByReactionType, (r) => r.reactionCode);
    }, [reactions]);
    const getTabId = (idx) => tabItems[idx].id;
    const getActiveTabReactionOwners = (idx) => {
        const reactionCode = getTabId(idx);
        return ownersByReactionType[reactionCode].list.map((item) => ({
            id: item,
            reactionCode,
        }));
    };
    const membersToRender = getTabId(activeTabIdx) === 'all' ? allReactionOwners : getActiveTabReactionOwners(activeTabIdx);
    const renderMembersList = () => (idx) => idx === activeTabIdx
        ? typeof renderChildren === 'function'
            ? renderChildren({
                membersToRender,
                mainReactionName,
                showReaction: getTabId(activeTabIdx) === 'all',
            })
            : renderChildren
        : null;
    return (React.createElement(Dialog, { className: st(classes.root, { isMobile }, cssVars.reactionsContainer), onClose: toggle, wiredToSiteColors: false, "data-hook": EMOTION_LIST_MODAL, isOpen: true },
        React.createElement("div", { className: classes.title },
            React.createElement(TextExtended, { isMobile: isMobile, typography: "titleSmall", priority: "black" }, t('reaction-list-modal.title'))),
        React.createElement(TabbedContent, { "data-hook": EMOTION_LIST_MODAL_TABLIST, className: classes.tabbedContentRoot, activeTabIndex: activeTabIdx, items: tabItems, alignment: isRtl ? ALIGNMENT.right : ALIGNMENT.left, onTabClick: (idx) => {
                onTabChange(getTabId(idx));
                setActiveTabIdx(idx);
            } }, renderMembersList())));
};
//# sourceMappingURL=emotion-list-modal-component.js.map